import Callback from '@/services/Callback'
import To from 'await-to-js'
import qs from 'qs'
import RecordOperation from '@/services/Record'
import { wizStandardInstance } from './instance'

export default class StdClassAttributeService {
  static async editattribute(payload) {
    RecordOperation({ type: 'update' })
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdClassAttribute/update_or_insert', payload)
    )
    return Callback(err, res)
  }
  static async listdetail(payload) {
    RecordOperation({ type: 'detail' })
    const [err, res] = await To(
      wizStandardInstance.get(`​/api/std/StdClassAttribute?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  static async detail(payload) {
    RecordOperation({ type: 'detail' })
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdClassAttribute/?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  static async list(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdClassAttribute?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  static async listNew(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/StdClassAttribute/get_list_pass_inherit?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  static async create(payload) {
    RecordOperation({ type: 'create' })
    const [err, res] = await To(wizStandardInstance.post('/api/std/StdClassAttribute', payload))
    return Callback(err, res)
  }
  static async update(payload) {
    RecordOperation({ type: 'update' })
    const [err, res] = await To(wizStandardInstance.patch('/api/std/StdClassAttribute', payload))
    return Callback(err, res)
  }
  static async updateRuleExpression(payload) {
    RecordOperation({ type: 'update' })
    const [err, res] = await To(
      wizStandardInstance.patch('/api/std/StdClassAttribute/RuleExpression', payload)
    )
    return Callback(err, res)
  }
  static async remove(payload) {
    RecordOperation({ type: 'delete' })
    const [err, res] = await To(wizStandardInstance.delete('/api/std/StdClassAttribute', payload))
    return Callback(err, res)
  }
  static async removeRuleExpress(payload) {
    RecordOperation({ type: 'delete' })
    const [err, res] = await To(
      wizStandardInstance.delete('/api/std/StdClassAttribute/RuleExpression', payload)
    )
    return Callback(err, res)
  }
  static async upload(payload) {
    RecordOperation({ type: 'import' })
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdClassAttribute/import', payload)
    )
    return Callback(err, res)
  }
  static async exportFile(payload) {
    RecordOperation({ type: 'export' })
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdClassAttribute/rule_expression_export', payload)
    )
    return Callback(err, res)
  }
  static async downloadTemplate(payload) {
    RecordOperation({ type: 'export' })
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdClassAttribute/download', payload)
    )
    return Callback(err, res)
  }
  static async getValueType(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get('/api/std/StdClassAttribute/get_value_type', payload)
    )
    return Callback(err, res)
  }
  static async validRuleExpression(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/StdClassAttribute/valid_rule_expression?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  static async getValidDefaultValueResult(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/StdClassAttribute/get_valid_default_value_result?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  static async getValidRuleExpression(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/StdClassAttribute/valid_rule_expression?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  static async getValue(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdClassData/code/attribute?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  static async getAnalysis(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/StdClassAttribute/get_impact_analysis?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 获取限定值列表
  static async getLimitValueList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdClassData/get_limit_value_list?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 获取参考数据编码
  static async getReferenceDataCode(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/StdClassData/get_reference_data_code?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 列表-参考数据项
  static async listReference(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/StdClassData/get_reference_data_value_list?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 新增-参考数据项
  static async addReference(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdClassData/add_reference_data_value', payload)
    )
    return Callback(err, res)
  }
  // 更新-参考数据项
  static async updateReference(payload) {
    const [err, res] = await To(
      wizStandardInstance.patch('/api/std/StdClassData/update_reference_data_value', payload)
    )
    return Callback(err, res)
  }
  // 删除-参考数据项
  static async deleteReference(payload) {
    const [err, res] = await To(
      wizStandardInstance.delete('/api/std/StdClassData/delete_reference_data_value', {
        data: payload,
      })
    )
    return Callback(err, res)
  }
  // 血缘分析-查询
  static async queryBloodData(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/StdClassAttribute/get_attribute_relation_tree?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 校验同一个实体下，属性中文名是否有重复
  static async checkAttributeName(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/StdClassAttribute/attribute_name_exist?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 用户配置显示列-修改
  static async editStduserconfig(payload) {
    const [err, res] = await To(wizStandardInstance.patch('/api/std/stduserconfig', payload))
    return Callback(err, res)
  }
  // 用户配置显示列-新增
  static async addStduserconfig(payload) {
    const [err, res] = await To(wizStandardInstance.post('/api/std/stduserconfig', payload))
    return Callback(err, res)
  }
  // 用户配置显示列-查询
  static async getStduserconfig(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/stduserconfig?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 下载模板
  static async downLoadTemp(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/StdDrawing/Get_Drawing_Details_Import_Template?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 导入
  static async importExcel(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdDrawing/Drawing_Details_Import', payload.formData)
    )
    return Callback(err, res)
  }
}
